/*eslint-disable */
import React, { Component } from "react";
import { Grid, Header, Icon, Button, Dropdown, Divider, Segment } from "semantic-ui-react";
import OrderDetailsHeader from "./OrderDetailsHeader";
import ReadAxios from "../../axiosComponent/read";
import PdfAxios from "../../axiosComponent/downloadpdf";
import FileCreatAxios from "../../axiosComponent/fileupload"
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import ShipmentOrderTable from "./shipmentOrderTable";
import { translate } from "react-i18next";
import VendorRepliesTable from "./vendorRepliesTable";
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { connect } from "react-redux";
import orders from "../../orderComponent/orders";
import moment from 'moment';
import BLrender from "../../common/bl_no";
import 'moment-timezone';
import DeliveryDetailComponentRebuilt from "./DeliveryDetailComponentRebuilt";


class ActiveOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderDetail: null,
      routeDetails: null,
      broadcastDetails: null,
      serviceType: null,
      order: null,
      files: [],
      broadcastTimeLeft: null,
      allow_bidding: null,
      // current_order: null,
      updateDoc: "",
      mystyle: {
        display: "table-cell",
        opacity: "1",
        verticalalign: "middle"
      },
      deliveryDetails: [],
      activeOrderLoading: false
    };
  }

  //   TODO: make both at same time
  async componentDidMount() {
    console.log(this.props.location);
    //console.log(this.props.location.state.item.broadcast_time_left);
    let shipmentId = this.props.location.search.split("=")[1];
    let vendorId = localStorage.getItem("vendorId")
    //TODO: null handling for api call
    console.log("in active order details")
    this.setState({
      activeOrderLoading: true
    })

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${shipmentId}/broadcast/vendor/${vendorId}`,
    })
      .then((res) => {

        console.log('shipment Details', this.state.orderDetail);
        console.log('orders', this.state.orders);

        let delivery_array = []
        let delivery_details = res.data.result.deliveries
        if (delivery_details) {
          for (const key in delivery_details) {
            if (delivery_details.hasOwnProperty(key)) {
              const element = delivery_details[key];
              delivery_array.push(element)
            }
          }
        }
        this.setState({
          deliveryDetails: delivery_array
        }, () => console.log(this.state.deliveryDetails))

        this.setState({
          orderDetail: res.data.result.shipment,
          serviceType: res.data.result.service_type,
          routeDetails: res.data.result.route_details,
          broadcastDetails: res.data.result.broadcast,
          order: res.data.result,
          broadcastTimeLeft: this.props.location.state.item.broadcast_time_left,
          allow_bidding: this.props.location.state.item.allow_bidding,
          uom: this.props.location.state.item.uom,
          forceUpdate: false,
          activeOrderLoading: false
        });
      })
      .catch((err) => {
        this.redirectToActiveOrdersPage()
        console.log(err);
        this.setState({
          activeOrderLoading: false
        })
      });
  }

  redirectToActiveOrdersPage = ()=>{
    this.props.history.push("/active-orders");
  }

  getDocType = (type) => {
    if (this.state.orderDetail.documents && this.state.orderDetail.documents.length > 0) {
      for (const docType of this.state.orderDetail.documents) {
        var docT = docType.doc_type
        var shipDocId = docType.filename
        if (type == docT) {
          return type == docT
        }
      }
    }
  }

  getfileName = (type) => {
    if (this.state.orderDetail.documents && this.state.orderDetail.documents.length > 0) {
      for (const docType of this.state.orderDetail.documents) {
        var docT = docType.doc_type
        var shipFileNeame = docType.filename
        if (type == docT) {
          return shipFileNeame
        }
        // return shipDocId
      }
    }
  }
  getDocId = (type) => {
    if (this.state.orderDetail.documents && this.state.orderDetail.documents.length > 0) {
      for (const docType of this.state.orderDetail.documents) {
        var docT = docType.doc_type
        var shipDocId = docType.shipment_doc_id
        if (type == docT) {
          return shipDocId
        }
        // return shipDocId
      }
    }
  }

  downloadFile = (id) => {
    setTimeout(() => {
      console.log(id);
    }, 2000);

    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${id}/download`,
    })
      .then((res) => {
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setCurrentOrderToShow = (name, data) => {
    this.setState({
      current_order: data.options.find((ele) => ele.value === data.value).key,
    });
  };

  uploadFile = (id) => {
    document.getElementById(id).click();
  }

  updateFile = (name, id, value) => {
    let values = { [name]: value }
    FileCreatAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/shipments/${id}/update-file`,
      payload: { ...values },
    })
      .then((res) => {
        this.props.success({
          type: "success",
          messageHeader: "Success",
          messageBody: "File Updated Successfully",
        });
        // window.location.reload();
      })
      .catch((err) => {
        this.props.error({
          type: "error",
          messageHeader: "Error",
          messageBody: err.response.data.error,
        });
        window.location.reload();
      });
  }

  getOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.state.shipmentId}`,
    })
      .then((res) => {
        this.setState({
          shipmentDetail: res.data.shipment,
        });
        console.log(this.state.shipmentDetail)
        if (this.state.shipmentDetail) {
          for (const key in this.state.shipmentDetail) {
            if (this.state.shipmentDetail.hasOwnProperty(key)) {
              const element = this.state.shipmentDetail[key];
              this.setState({
                documents: element
              })
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //   TODO: null handling
  render() {
    const { orderDetail, serviceType } = this.state;
    const { t } = this.props;
    const documents = this.state.orderDetail;
    const routeDetails = this.state.routeDetails;
    const broadcastDetails = this.state.broadcastDetails;
    const deliveries = this.state.deliveryDetails;
    const order = this.state.order;
    const activeOrderLoading = this.state.activeOrderLoading
    let doc = '';

    if (activeOrderLoading) {
      return <LoadingPlaceholder />
    } else {
      return (
        <React.Fragment>
          <OrderDetailsHeader
            title={t("active_title") || "Active Order Details"}
            LinkName="/active-orders"
            broadcastTimeLeft={this.state.broadcastTimeLeft}
            bidding={this.state.allow_bidding}
            uom={this.state.uom}
            hideUpdateDetails={true}
            order_status="active"
            offered_rate={broadcastDetails ? broadcastDetails.base_rate : ""}
            vendor_interest_status={order ? order.vendor_interest_status : ""}
            orderDetail={order}
          />

          {orderDetail ? (
            <>
              {order.vendor_interest_status == "REBID" ? (

                <Segment color='yellow' className="m-3 p-2 p1-3" >
                  <h6 className="p-bold-600 labelName small">Rebid Request | {order.rebid_note}</h6>
                </Segment>

              ) : ""}

              <div className="pad w3-white small">
                {console.log("Datatatatatat", deliveries)}
                <Header as='h5' dividing className="m-2 mb-4 p-bold-600 small">
                  {t("broadcast_details") || "Broadcast Details"}
                </Header>
                <Grid columns={4} className="ml-2" >
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("broadcast_start") || "Broadcast Start Date & Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {moment.parseZone(broadcastDetails.broadcast_start_datetime).format('DD-MM-YYYY HH:mm')}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("broadcast_end") || "Broadcast End Date & Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {moment.parseZone(broadcastDetails.broadcast_end_datetime).format('DD-MM-YYYY HH:mm')}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("time_left_to_respond") || "Time Left to Respond"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {this.state.broadcastTimeLeft}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("offered_rate") || "Offered Rate"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.base_rate}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("uom") || "Uom"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.uom}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("return_load") || "Return Load"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.return_load == true ? t("available") || "Available" : t("not_available") || 'Not Available'}
                    </Header>
                  </Grid.Column>

                  {localStorage.getItem('customerNumber') == "2" ?
                    <>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("loading_done_by.title") || "Loading Done By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.loading_done_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("loading_charges.title") || "Loading Charges"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.loading_charges}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("unloading_done_by.title") || "Unloading Done By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.unloading_done_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("unloading_charges.title") || "Unloading Charges"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.unloading_charges}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("insured_by.title") || "Insured By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.insured_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("advance_payment.title") || "Advance Payment"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.advance_payment}%
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("credit_period_for_settlement.title") || "Credit Period For Settlement"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.credit_period_for_settlement}
                        </Header>
                      </Grid.Column>
                    </>
                    : null}

                </Grid>
              </div>

              <div className="pad w3-white small">
                <Grid className="ml-2">
                  <Grid.Column width={3} >
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {localStorage.getItem('customerNumber') == 1166 ? "Booking No" : t("order_number") || "Order Number"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {order.order_reference_no}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {orderDetail.movement_type == "Import" || orderDetail.movement_type == "Importar" ? t("estimated_on") : t("required_on")}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {localStorage.getItem('customerNumber') == 1122 ?
                        moment.parseZone(orderDetail.required_on).format('DD-MM-YYYY')
                        :
                        moment.parseZone(orderDetail.required_on).format('DD-MM-YYYY HH:mm')
                      }
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("route") || "Route"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {routeDetails.source} - {routeDetails.destination}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("movement_type") || "Movement Type"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName  movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {orderDetail.movement_type}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("proposed_vehicle_type") || "Proposed Vehicle Type"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {order.vehicle_type}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("from_location") || "Origin"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {routeDetails.source}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("to_location") || "Destination"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {routeDetails.destination}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("weight") || "Net weight"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {order.gross_weight}
                    </Header>
                  </Grid.Column>

                  {orderDetail.movement_type == "Import" || orderDetail.movement_type == "Importar" ?
                    <>
                      {/* <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("import_decleration_number") || "Import Declaration No."}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName movement_type"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {orderDetail.import_declaration_no ? orderDetail.import_declaration_no : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("boarding_no") || "Boarding No."}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName movement_type"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {orderDetail.boarding_no ? orderDetail.boarding_no : "NA"}
                        </Header>
                      </Grid.Column> */}
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("bl_no") || "BL No."}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName movement_type"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          <BLrender id={order.vendor_order_id} />
                        </Header>
                      </Grid.Column>
                    </>
                    : ""}

                </Grid>
              </div>

              {deliveries ?
                <div className="pad w3-white small">
                  <DeliveryDetailComponentRebuilt
                    deliveries={deliveries}
                    t={t}
                    orderDetail={orderDetail}
                    getOrderDetails={this.getOrderDetails}
                    activeOrder={true}
                    serviceType={serviceType}
                    {...this.props}
                  />
                </div>
                :
                ""
              }
            </>
          ) : (
            <LoadingPlaceholder />
          )}

        </React.Fragment>
      );

    }


  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(translate("order_details")(ActiveOrderDetails));
